"use client";

import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import useRightEdgeSwipe from "@/components/hooks/use-right-edge-swipe";
import DrawerProvider from "../provider";
import type { DrawerProps } from "../types";

function DrawerRoot({
  shouldScaleBackground = true,
  direction = "right",
  ...props
}: DrawerProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOnOpenChange = React.useCallback((value: boolean) => {
    setIsOpen(value);
  }, []);

  const handleOnSwipe = React.useCallback(() => {
    if (isOpen) {
      return;
    }

    setIsOpen(true);
  }, [isOpen]);

  useRightEdgeSwipe(handleOnSwipe);

  return (
    <DrawerProvider direction={direction}>
      <DrawerPrimitive.Root
        data-slot="drawer"
        shouldScaleBackground={shouldScaleBackground}
        direction={direction}
        open={isOpen}
        onOpenChange={handleOnOpenChange}
        {...(props as typeof DrawerPrimitive.Root)}
      />
    </DrawerProvider>
  );
}

DrawerRoot.displayName = "Drawer";

export default DrawerRoot;
